document.addEventListener("DOMContentLoaded", () => {
  // Only apply this if screen width is above 990px
  const isWide = window.matchMedia("(min-width: 990px)").matches;

  if (!isWide) return;

  const grid = document.querySelector('.custom-collection-grid');
  const wrapper = document.querySelector('.flex-row-wrapper');

  const allGridItems = Array.from(grid.children);
  const itemsPerRow = 3;
  const total = allGridItems.length;
  const remainder = total % itemsPerRow;

  if (remainder > 0) {
    const lastRowItems = allGridItems.slice(-remainder);
    lastRowItems.forEach(item => {
      wrapper.appendChild(item); // Move to flex wrapper
    });
  }
});
